import React, { Fragment } from "react";
import LOGO from "../assets/images/logo.png";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
// import './mainnav.css';

const discordIcon = (
  <svg
    enableBackground="new 0 0 512 512"
    id="Layer_1"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
  >
    <path
      cx={256}
      cy={256}
      fill="#8C9EFF"
      id="ellipse"
      r={256}
      d="M24 12A12 12 0 0 1 12 24A12 12 0 0 1 0 12A12 12 0 0 1 24 12z"
    />
    <path
      d="M17.456 7.908s-1.561 -1.223 -3.408 -1.364l-0.164 0.333c1.669 0.408 2.433 0.994 3.234 1.711 -1.378 -0.703 -2.742 -1.364 -5.114 -1.364s-3.736 0.661 -5.114 1.364c0.802 -0.717 1.711 -1.369 3.234 -1.711l-0.164 -0.333c-1.936 0.183 -3.408 1.364 -3.408 1.364s-1.744 2.531 -2.044 7.5c1.758 2.03 4.43 2.044 4.43 2.044l0.558 -0.745c-0.947 -0.328 -2.02 -0.919 -2.944 -1.983 1.102 0.834 2.77 1.706 5.456 1.706S16.359 15.563 17.466 14.723c-0.923 1.064 -1.997 1.655 -2.944 1.983l0.558 0.745s2.672 -0.014 4.43 -2.044c-0.309 -4.969 -2.053 -7.5 -2.053 -7.5zM9.783 14.044c-0.661 0 -1.195 -0.609 -1.195 -1.364s0.534 -1.364 1.195 -1.364 1.195 0.609 1.195 1.364 -0.534 1.364 -1.195 1.364zm4.434 0c-0.661 0 -1.195 -0.609 -1.195 -1.364s0.534 -1.364 1.195 -1.364 1.195 0.609 1.195 1.364 -0.539 1.364 -1.195 1.364z"
      fill="#FFFFFF"
      id="logo"
    />
  </svg>
);

const twitterIcon = (
  <svg
    enableBackground="new 0 0 48 48"
    id="Layer_1"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
  >
    <path
      cx={24}
      cy={24}
      fill="#1CB7EB"
      r={24}
      d="M24 12A12 12 0 0 1 12 24A12 12 0 0 1 0 12A12 12 0 0 1 24 12z"
    />
    <g>
      <g>
        <path
          d="M18.4 7.7c-0.45 0.25 -1 0.4 -1.5 0.45 0.55 -0.35 0.95 -0.9 1.15 -1.55 -0.5 0.3 -1.05 0.55 -1.7 0.7 -0.5 -0.55 -1.15 -0.9 -1.9 -0.9 -1.45 0 -2.65 1.25 -2.65 2.85 0 0.2 0 0.45 0.05 0.65 -2.2 -0.1 -4.15 -1.25 -5.45 -2.95 -0.25 0.4 -0.35 0.9 -0.35 1.45 0 1 0.45 1.85 1.15 2.35 -0.45 0 -0.85 -0.15 -1.2 -0.35v0.05c0 1.35 0.9 2.5 2.1 2.8 -0.2 0.05 -0.45 0.1 -0.7 0.1 -0.15 0 -0.35 0 -0.5 -0.05 0.35 1.15 1.3 1.95 2.45 1.95 -0.9 0.75 -2.05 1.2 -3.25 1.2 -0.2 0 -0.4 0 -0.65 -0.05 1.15 0.8 2.55 1.3 4.05 1.3 4.85 0 7.5 -4.3 7.5 -8.05v-0.35c0.6 -0.5 1.05 -1 1.4 -1.6z"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);

const Header = () => {
  return (
    <Fragment>
      <div expand="lg" className="pt-3 px-10 bg-[#444444]">
        <div className="flex items-center justify-between navbar">
          <div>
            <a href="/">
              <img
                src={LOGO}
                alt="lone wolf logo"
                width={100}
                className="top-nav"
              />
            </a>
          </div>
          <div className="text-white">
            <a href="https://lonewolfstudios.io/">Home</a>
          </div>
          <div className="flex flex-row gap-2">
            <a href="https://discord.gg/2WWJbgBP5T" target="_blank" rel="noreferrer">
              <button>{discordIcon}</button>
            </a>
            <a href="https://twitter.com/lone_wolf_nftsM" target="_blank" rel="noreferrer">
              <button>{twitterIcon}</button>
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
